import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { GuideComponent } from './guide/guide.component';
import { GuideGlossaryComponent } from './guide-glossary/guide-glossary.component';
import { GuideMapComponent } from './guide-map/guide-map.component';
import { GuideMapManufacturingProcessComponent } from './guide-map/components/guide-map-manufacturing-process/guide-map-manufacturing-process.component';
import { GuideMapOutsoursingProcurementComponent } from './guide-map/components/guide-map-outsoursing-procurement/guide-map-outsoursing-procurement.component';
import { GuideMapProductionListPreparationByWarehouseComponent } from './guide-map/components/guide-map-production-list-preparation-by-warehouse/guide-map-production-list-preparation-by-warehouse.component';
import { GuideMapProductionListProcurementComponent } from './guide-map/components/guide-map-production-list-procurement/guide-map-production-list-procurement.component';
import { GuideMapProductionRequestProcessingComponent } from './guide-map/components/guide-map-production-request-processing/guide-map-production-request-processing.component';
import { AccordionModule } from 'primeng/accordion';
import { CardModule } from 'primeng/card';
import { SafeUrlPipe } from '@shared/pipes/safe-url.pipe';

@NgModule({
  declarations: [
    GuideComponent,
    GuideGlossaryComponent,
    GuideMapComponent,
    GuideMapManufacturingProcessComponent,
    GuideMapOutsoursingProcurementComponent,
    GuideMapProductionListPreparationByWarehouseComponent,
    GuideMapProductionListProcurementComponent,
    GuideMapProductionRequestProcessingComponent,
  ],
  exports: [
    GuideComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    AccordionModule,
    CardModule,
    SafeUrlPipe,
  ]
})
export class GuideModule {
}
